import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCog,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./MyTraining.css";

function MyTraining({
  id,
  name,
  name_english,
  group,
  group_english,
  date,
  status,
  userId,
  stateUserId,
  role,
  language,
  handleShow,
}) {
  const { t } = useTranslation();

  const selectColor = (status) => {
    if (status === "approved") {
      return (
        <span className="training-approved">
          {t("Capacitaciones.MiCapacitacion.Aprobado")}
        </span>
      );
    } else if (status === "pending") {
      return (
        <span className="training-pending">
          {t("Capacitaciones.MiCapacitacion.Pendiente")}
        </span>
      );
    } else if (status === "overdue") {
      return (
        <span className="training-overdue">
          {t("Capacitaciones.MiCapacitacion.Expirado")}
        </span>
      );
    } else if (status === "completed") {
      return (
        <span className="training-completed">
          {t("Capacitaciones.MiCapacitacion.Completado")}
        </span>
      );
    }
  };

  const generateContent = (role, userId, stateUserId) => {
    if (role === "admin" || role === "root") {
      if (status === "pending") {
        return (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faCog} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {userId === stateUserId ? (
                <Dropdown.Item
                  as={Link}
                  to={`/mytraining/edit/${id}/${userId}`}
                >
                  <FontAwesomeIcon icon={faEdit} />{" "}
                  {t("Capacitaciones.MiCapacitacion.Actualizar")}
                </Dropdown.Item>
              ) : (
                <></>
              )}
              <Dropdown.Item
                as={Link}
                to={`/trainings/details/${id}/${userId}`}
              >
                <FontAwesomeIcon icon={faCheck} />{" "}
                {t("Capacitaciones.MiCapacitacion.Validar")}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleShow(id)}>
                <FontAwesomeIcon icon={faTrash} />{" "}
                {t("Capacitaciones.MiCapacitacion.Eliminar")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        );
      } else if (status === "completed") {
        return (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faCog} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                as={Link}
                to={`/trainings/details/${id}/${userId}`}
              >
                <FontAwesomeIcon icon={faCheck} />{" "}
                {t("Capacitaciones.MiCapacitacion.Validar")}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleShow(id)}>
                <FontAwesomeIcon icon={faTrash} />{" "}
                {t("Capacitaciones.MiCapacitacion.Eliminar")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        );
      } else if (status === "approved") {
        return <></>;
      }
    } else {
      if (status === "pending") {
        return (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faCog} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {userId === stateUserId ? (
                <Dropdown.Item
                  as={Link}
                  to={`/mytraining/edit/${id}/${userId}`}
                >
                  <FontAwesomeIcon icon={faEdit} />{" "}
                  {t("Capacitaciones.MiCapacitacion.Actualizar")}
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  as={Link}
                  to={`/trainings/details/${id}/${userId}`}
                >
                  <FontAwesomeIcon icon={faCheck} />{" "}
                  {t("Capacitaciones.MiCapacitacion.Validar")}
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        );
      } else if (status === "completed") {
        if (userId !== stateUserId) {
          return (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faCog} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={`/trainings/details/${id}/${userId}`}
                >
                  <FontAwesomeIcon icon={faCheck} />{" "}
                  {t("Capacitaciones.MiCapacitacion.Validar")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        } else {
          return <></>;
        }
      } else if (status === "approved") {
        return <></>;
      }
    }
  };

  return (
    <Row className="mytraining align-items-center">
      <Col lg={6} className="mytraining-header">
        <h5>{language === "es" ? name : name_english}</h5>
        <p>{language === "es" ? group : group_english}</p>
      </Col>
      <Col lg={2} className="mytraining-date">
        <h5>{date !== null ? "" : date}</h5>
      </Col>
      <Col lg={2} className="mytraining-status">
        {selectColor(status)}
      </Col>
      <Col lg={2} className="mytraining-content">
        {generateContent(role, userId, stateUserId)}
      </Col>
    </Row>
  );
}

export default MyTraining;
